export default __webpack_public_path__ + "static/about-me-ee847940c5e4b4b12db8755d119adb68.svg";